export default {"src":"/_next/static/media/secure.bb418346.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};